import {course_getCourseSubjects_Api} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncWithCache from 'modules/asyncCache/useAsyncWithCache'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useMemo, useState} from 'react'
import {branch, compose, renderNothing} from 'recompose'
import AntdConfigWrapper, {RenderEmptyMeta,} from 'views/AppLocals/custom/AntdConfigWrapper'
import {reactSelectComponents, SelectWidget,} from 'views/AppLocals/custom/ReactSelectComponents'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {getResponseItems, NullAsDefault} from 'views/Shared'

const FilterSelectField = ({
  name,
  value,
  onChange,
  options,
  isLoading,
  className,
  ...props
}) => (
  <AntdConfigWrapper renderEmpty={RenderEmptyMeta}>
    <SelectWidget
      value={_.find(options, { value }) ? value : undefined}
      showSearch={true}
      allowClear={true}
      onChange={(value) => {
        onChange(name, value)
      }}
      loading={!!isLoading}
      optionFilterProp="label"
      className={classNames('CenterSelector w-full', className)}
      options={!!isLoading ? [] : options}
      suffixIcon={
        !!isLoading ? undefined : <reactSelectComponents.DropdownIndicator />
      }
      {...props}
    />
  </AntdConfigWrapper>
)

const SubjectAsyncWrapper = compose(
  branch(({ course_id }) => !course_id, renderNothing)
)(({ course_id, children }) => {
  const [values, setValues] = useState()

  const apiInfo = course_getCourseSubjects_Api
  const cacheId = useMemo(
    () =>
      [apiInfo.path.replace(':id', course_id), JSON.stringify(values)].join(
        '/'
      ),
    [values, course_id]
  )

  const { response, isLoading } = useAsyncWithCache({
    values,
    cacheId,
    apiInfo,
    query: bindQueryParam({ id: course_id }),
  })

  return _.isFunction(children)
    ? children({
        isLoading,
        items: getResponseItems(response),
        onSearch: (keyword) => {
          setValues({
            keyword,
          })
        },
      })
    : children
})

export const CouseClassGradeFilter = ({
  owner_id,
  owner_type,
  defaultValue,
  value: filter = {
    course_id: undefined,
    subject_id: undefined,
  },
  onChange: setValues = NullAsDefault,
}) => {
  const t = useTranslate()

  const handleChange = useCallback(
    (name, value) => {
      const params = {
        ...filter,
        [name]: value,
      }
      setValues(params)
      return params
    },
    [filter]
  )

  return (
    <div className="flex flex-col items-center gap-2 mt-2">
      <React.Fragment>
        <SubjectAsyncWrapper {...{ course_id: owner_id }}>
          {({ items, isLoading }) => {
            const options = Array.from(items).map((option) => {
              const subject = option?.subject
              return {
                value: getId(subject),
                label: getTitle(subject),
              }
            })
            return (
              <div className="flex items-center gap-2 w-full">
                <span className="text-sm text-color-400 italic whitespace-no-wrap">
                  {`${t('choose subject')} : `}
                </span>
                <FilterSelectField
                  name="subject_id"
                  options={options}
                  loading={isLoading}
                  value={filter.subject_id}
                  placeholder={t(isLoading ? 'loading...' : 'subjects')}
                  onChange={(name, value) => {
                    handleChange(name, value)
                  }}
                />
              </div>
            )
          }}
        </SubjectAsyncWrapper>
      </React.Fragment>
    </div>
  )
}

export default CouseClassGradeFilter
